<div class="d-flex flex-column flex-md-row align-items-center p-2 px-md-4 mb-3 bg-white border-bottom mat-elevation-z0">

  <h5 class="my-0 mr-md-auto font-weight-normal" routerLink="/"><img src="assets/img/icbeu2.png" height="60"></h5>
  <nav class="my-2 my-md-0 mr-md-3 d-none d-sm-block">
    <a class="p-2 text-dark" routerLink="/">Home</a>
    <a class="p-2 text-dark" href="http://icbeu.com/">Portal Icbeu</a>
  </nav>
  <a class="btn btn-outline-primary d-none d-sm-block" routerLink="/login">Fazer Login</a>
</div>
<div class="row">
  <div class="container">
    <div class="col-12">
      <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
        <h1 class="display-4">Torne-se aluno</h1>
        <p class="lead">Estude em uma instituição de qualidade! Basta preencher os campos abaixo e enviaremos um
          email para você, contendo informações para o próximo passo.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">   
    <div class="col-md-5 mb-5">
      <form [formGroup]="registerForm" (submit)="onSubmit()" autocomplete="off" novalidate>
        <h5>Crie uma conta com seu email</h5>

        <div class="form-row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome</mat-label>
              <input 
                matInput 
                placeholder="Informe seu nome"
                formControlName="name"
              >
              <mat-icon matSuffix>assignment_ind</mat-icon>
              <mat-error *ngIf="registerForm.get('name').touched && registerForm.get('name').hasError('required')">
                O nome é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('name').touched && registerForm.get('name').hasError('minlength')">
                O nome deve conter <strong>mais de 3 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('name').touched && registerForm.get('name').hasError('maxlength')">
                O nome deve ter no <strong>máximo 255 caracteres</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <input 
                matInput 
                placeholder="Informe seu email"
                formControlName="email"
              >
              <mat-icon matSuffix>email</mat-icon>
              <mat-error *ngIf="registerForm.get('email').touched && registerForm.get('email').hasError('required')">
                O email é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('email').touched && registerForm.get('email').hasError('minlength')">
                O email deve conter <strong>mais de 3 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('email').touched && registerForm.get('email').hasError('maxlength')">
                O email deve ter no <strong>máximo 60 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('email').touched && registerForm.get('email').hasError('pattern')">
                Email <strong>inválido</strong>
              </mat-error>
            </mat-form-field>

          </div>
          <div class="col-12">         
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Confirmar email</mat-label>
              <input 
                matInput 
                placeholder="Confirme seu email"
                formControlName="confirmEmail"
              >
              <mat-icon matSuffix>email</mat-icon>
              <mat-error *ngIf="registerForm.get('confirmEmail').touched && registerForm.get('confirmEmail').hasError('required')">
                A confirmação de email é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('confirmEmail').touched && registerForm.get('confirmEmail').hasError('minlength')">
                A confirmação de email deve conter <strong>mais de 3 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('confirmEmail').touched && registerForm.get('confirmEmail').hasError('maxlength')">
                O confirmação de email deve ter no <strong>máximo 60 caracteres</strong>
              </mat-error>
             
              <mat-error *ngIf="registerForm.get('confirmEmail').touched && registerForm.get('confirmEmail').hasError('pattern')">
                Email <strong>inválido</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Telefone</mat-label>
              <input 
                matInput 
                placeholder="(92) 99999-9999"
                mask="(00) 00000-0000"
                formControlName="phone"
              >
              <mat-icon matSuffix>smartphone</mat-icon>
              <mat-error *ngIf="registerForm.get('phone').touched && registerForm.get('phone').hasError('required')">
                Telefone é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('phone').touched && registerForm.get('phone').hasError('maxlength')">
                Telefone é deve ter no <strong>máximo 11 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('phone').touched && registerForm.get('phone').hasError('minlength')">
                Telefone é deve ter no <strong>mínimo 11 caracteres</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Nascimento</mat-label>
              <input 
                matInput 
                placeholder="00/00/0000"
                mask="00/00/0000"
                [dropSpecialCharacters]="false"
                formControlName="birthday"
              >
              <mat-icon matSuffix>event_note</mat-icon>
              <mat-error *ngIf="registerForm.get('birthday').touched && registerForm.get('birthday').hasError('required')">
                Data de Nascimento é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('phone').touched && registerForm.get('phone').hasError('maxlength')">
                Data de nascimento é deve ter no <strong>máximo 8 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('phone').touched && registerForm.get('phone').hasError('minlength')">
                Data de nascimento é deve ter no <strong>mínimo 8 caracteres</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome da Mãe</mat-label>
              <input 
                matInput 
                placeholder="Informe o nome da sua mãe"
                formControlName="nameMother"
              >
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="registerForm.get('nameMother').touched && registerForm.get('nameMother').hasError('required')">
                Nome da mãe é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('nameMother').touched && registerForm.get('nameMother').hasError('minlength')">
                O nome deve conter <strong>mais de 3 caracteres</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('nameMother').touched && registerForm.get('nameMother').hasError('maxlength')">
                O nome deve ter no <strong>máximo 255 caracteres</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CPF</mat-label>
              <input 
                matInput 
                placeholder="000.000.000-00"
                mask="000.000.000-00"
                formControlName="cpf"
              >
              <mat-icon matSuffix>portrait</mat-icon>
              <mat-error *ngIf="registerForm.get('cpf').touched && registerForm.get('cpf').hasError('required')">
                CPF é <strong>obrigatório</strong>
              </mat-error>
              <mat-error *ngIf="registerForm.get('cpf').touched && registerForm.get('cpf').hasError('cpfNotValid')">
                CPF <strong>inválido</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <button 
          type="submit"
          mat-flat-button 
          class="mt-3 btn-block py-2 btn-lg btn-register"
          [disabled]="!registerForm.valid || submittingForm"
        > {{ submittingForm ? 'Aguarde... registrando sua conta' : 'Criar conta'}}</button>

        <div *ngIf="messagesErrors.length > 0">
          <div class="alert alert-danger mt-3 " role="alert">
            <h4 class="font-weight-bold">Erros encontrados: </h4>
            <ul class="my-2 px-4" *ngFor="let msg of messagesErrors">
              <li> {{ msg.msg }}</li>
            </ul>
          </div>
        </div>

        <div *ngIf="returnMessage">
          <div class="alert alert-success mt-3 font-weight-bold" role="alert">
            {{ returnMessage }}
          </div>
        </div>

      </form>
    </div><!-- col-md-5 -->
    <div class="col-md-7 vantagens">
      <div class="row ml-md-5">
        <div class="col-12">
          <div class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 border-0 h-md-250 position-relative">
            <div class="col-1">
              <mat-icon class="">school</mat-icon>
            </div>
            <div class="col p-0 d-flex flex-column position-static">
              <h3 class="mb-0 text-uppercase font-weight-bold">Nosso corpo docente</h3>              
              <p class="card-text mb-auto lead description font-italic">é composto por professores graduados e pós-graduados em metodologia do ensino do inglês. Além disso, recebem treinamentos contínuos e participam de cursos oferecidos por diversas instituições, universidades e editoras internacionais.</p>              
            </div>            
          </div>
        </div>
        <hr>
        <div class="col-12">
         <div class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 border-0 h-md-250 position-relative">
            <div class="col-1">
              <mat-icon class="">airplay</mat-icon>
            </div>
            <div class="col p-0 d-flex flex-column position-static">
              <h3 class="mb-0 text-uppercase font-weight-bold">Contamos com um makerspace</h3>              
              <p class="card-text mb-auto lead description font-italic">Makerspace bilíngue que possui um espaço para aulas práticas, tanto para alunos como para a comunidade. São aulas das mais diversas áreas como: gastronomia, robótica, edição de imagem e vídeo, programação, impressão 3D e muito mais!</p>              
            </div>            
          </div>
        </div>
        <div class="col-12">
          <div class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 border-0 h-md-250 position-relative">
            <div class="col-1">
              <mat-icon class="">people</mat-icon>
            </div>
            <div class="col p-0 d-flex flex-column position-static">
              <h3 class="mb-0 text-uppercase font-weight-bolder">Nossos cursos são voltados para crianças, jovens e adultos</h3>              
              <p class="card-text mb-auto lead description font-italic">Os pequenos de 3 a 6 anos conta com um espaço voltado especialmente para esta faixa etária, com um projeto pedagógico renovado, com atividades diferenciadas e alinhadas com que há de mais moderno no ensino da língua para o público infantil.</p>              
            </div>            
          </div>
        </div>            
      </div>
    </div><!-- ./ col-md-7 -->
  </div><!--  /.row -->
  <footer class="pt-4 my-md-5 pt-md-5 border-top">
    <div class="row">
      <div class="col-12 col-md">
        <img class="mb-2" src="assets/img/icbeu.png" alt="" width="24" height="24">
        <small class="d-block mb-3 text-muted">&copy; 2019</small>
      </div>
      <div class="col-6 col-md">
        <h5>O ICBEU</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="http://icbeu.com/">Home</a></li>
          <li><a class="text-muted" href="http://icbeu.com/quem-somos/">Quem somos</a></li>
          <li><a class="text-muted" href="http://icbeu.com/cursos/">Cursos</a></li>
          <li><a class="text-muted" href="http://icbeu.com/conheca-o-icbeu/">Conheça o ICBEU</a></li>
          <li><a class="text-muted" href="http://icbeu.com/faq/">FAQ</a></li>
          <li><a class="text-muted" href="http://icbeu.com/convenios-e-parcerias/">Convênios e Parcerias</a></li>
          <li><a class="text-muted" href="http://icbeu.com/contrato-e-regulamento/">Contrato e Regulamento</a></li>
          <li><a class="text-muted" href="http://icbeu.com/resultados-e-informacoes/">Resultados e Informações</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Diferencial</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="http://icbeu.com/metodologia/">Metodologia</a></li>
          <li><a class="text-muted" href="https://www.instagram.com/makerspaceicbeumanaus/">MakerSpace</a></li>
          <li><a class="text-muted" href="http://icbeu.com/biblioteca/">Biblioteca</a></li>
          <li><a class="text-muted" href="http://icbeu.com/coral/">Coral</a></li>
          <li><a class="text-muted" href="http://icbeu.com/certificacoes/">Certificações</a></li>
          <li><a class="text-muted" href="http://icbeu.com/bons-motivos/">Bons Motivos</a></li>
          <li><a class="text-muted" href="http://icbeu.com/educationusa/">Education USA</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Blog</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="http://icbeu.com/2019/01/16/makerspace/#sthash.lRXbmtmu.dpbs">
              <b>Makerspace</b> Saiba tudo sobre esse espaço...</a></li>
          <li><a class="text-muted" href="http://icbeu.com/2019/01/09/curso-anytime/#sthash.nHyBi9CW.dpbs">Saiba tudo
              sobre o <b> Curso Anytime</b>...</a></li>
        </ul>
      </div>
    </div>
  </footer>
</div><!-- /.container-->
